import { Validator } from "./validator";

export const isEmaillessUser = (user: { email?: string }): boolean =>
  new Validator().validateEmail(user.email ?? "") !== undefined;
